import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_2,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_6,
} from './operators';

const DOMAIN_CONDITIONS = [
  {
    key: 'qualification_status',
    name: 'QUALIFICATION_STATUS',
    inputType: 'plain_text',
    filterOperators: OPERATOR_TYPES_1,
  },
  {
    key: 'contact_type',
    name: 'CONTACT_TYPE',
    inputType: 'plain_text',
    filterOperators: OPERATOR_TYPES_1,
  },
  {
    key: 'tem_visita_futura',
    name: 'HAS_FUTURE_VISIT',
    inputType: 'plain_text',
    filterOperators: OPERATOR_TYPES_1,
  },
  {
    key: 'finalidade',
    name: 'LISTING_PURPOSE',
    inputType: 'plain_text',
    filterOperators: OPERATOR_TYPES_1,
  },
  {
    key: 'bairro',
    name: 'NEIGHBORHOOD',
    inputType: 'plain_text',
    filterOperators: OPERATOR_TYPES_2,
  },
  ...[
    ['task_type', 'TASK_TYPE'],
    ['task_status', 'TASK_STATUS'],
    ['task_priority', 'TASK_PRIORITY'],
    ['task_waiting_on', 'TASK_WAITING_ON'],
    ['task_assignee_id', 'TASK_ASSIGNEE_ID'],
    ['task_team_id', 'TASK_TEAM_ID'],
    ['task_due_at', 'TASK_DUE_AT'],
    ['visit_status', 'VISIT_STATUS'],
    ['visit_scheduled_at', 'VISIT_SCHEDULED_AT'],
    ['visit_checkin_status', 'VISIT_CHECKIN_STATUS'],
    ['offer_status', 'OFFER_STATUS'],
    ['offer_kind', 'OFFER_KIND'],
    ['offer_business_context', 'OFFER_BUSINESS_CONTEXT'],
    ['offer_amount', 'OFFER_AMOUNT'],
    ['transaction_status', 'TRANSACTION_STATUS'],
    ['transaction_kind', 'TRANSACTION_KIND'],
    ['transaction_public_status', 'TRANSACTION_PUBLIC_STATUS'],
  ].map(([key, name]) => ({
    key,
    name,
    inputType: 'plain_text',
    filterOperators: OPERATOR_TYPES_1,
  })),
];

const DOMAIN_ACTIONS = [
  {
    key: 'recommend_imoveis',
    name: 'RECOMMEND_IMOVEIS',
  },
  {
    key: 'notify_agent',
    name: 'NOTIFY_AGENT',
  },
  {
    key: 'send_whatsapp_template',
    name: 'SEND_WHATSAPP_TEMPLATE',
  },
  {
    key: 'add_to_nurture_cadence',
    name: 'ADD_TO_NURTURE_CADENCE',
  },
  {
    key: 'route_imovel_lead',
    name: 'ROUTE_IMOVEL_LEAD',
  },
  {
    key: 'send_survey',
    name: 'SEND_SURVEY',
  },
  {
    key: 'dispatch_notification',
    name: 'DISPATCH_NOTIFICATION',
  },
  {
    key: 'add_label',
    name: 'ADD_LABEL',
  },
  {
    key: 'send_message',
    name: 'SEND_MESSAGE',
  },
  {
    key: 'add_private_note',
    name: 'ADD_PRIVATE_NOTE',
  },
  {
    key: 'assign_agent',
    name: 'ASSIGN_AGENT',
  },
  {
    key: 'assign_team',
    name: 'ASSIGN_TEAM',
  },
  {
    key: 'create_crm_task',
    name: 'CREATE_CRM_TASK',
  },
  {
    key: 'sync_domain_crm_task',
    name: 'SYNC_DOMAIN_CRM_TASK',
  },
];

const DOMAIN_AUTOMATION = {
  conditions: DOMAIN_CONDITIONS,
  actions: DOMAIN_ACTIONS,
};

const CONTACT_DOMAIN_ACTIONS = DOMAIN_ACTIONS.filter(({ key }) =>
  ['add_to_nurture_cadence', 'send_survey', 'dispatch_notification'].includes(
    key
  )
);

const CONTACT_DOMAIN_AUTOMATION = {
  conditions: DOMAIN_CONDITIONS,
  actions: CONTACT_DOMAIN_ACTIONS,
};

const FINANCIAL_DOMAIN_ACTIONS = DOMAIN_ACTIONS.filter(({ key }) =>
  [
    'add_to_nurture_cadence',
    'send_survey',
    'dispatch_notification',
    'create_crm_task',
  ].includes(key)
);

const FINANCIAL_DOMAIN_AUTOMATION = {
  conditions: DOMAIN_CONDITIONS,
  actions: FINANCIAL_DOMAIN_ACTIONS,
};

export const AUTOMATIONS = {
  message_created: {
    conditions: [
      {
        key: 'message_type',
        name: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'content',
        name: 'MESSAGE_CONTAINS',
        inputType: 'comma_separated_plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_created: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_updated: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_opened: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_resolved: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'send_survey',
        name: 'SEND_SURVEY',
      },
    ],
  },
  visit_requested: DOMAIN_AUTOMATION,
  visit_confirmed: DOMAIN_AUTOMATION,
  visit_rescheduled: DOMAIN_AUTOMATION,
  visit_canceled: DOMAIN_AUTOMATION,
  visit_completed: DOMAIN_AUTOMATION,
  visit_no_show: DOMAIN_AUTOMATION,
  visit_stalled: DOMAIN_AUTOMATION,
  visit_unsuccessful: DOMAIN_AUTOMATION,
  offer_created: DOMAIN_AUTOMATION,
  offer_submitted: DOMAIN_AUTOMATION,
  offer_countered: DOMAIN_AUTOMATION,
  offer_accepted: DOMAIN_AUTOMATION,
  offer_declined: DOMAIN_AUTOMATION,
  offer_expired: DOMAIN_AUTOMATION,
  offer_withdrawn: DOMAIN_AUTOMATION,
  offer_contract_drafted: DOMAIN_AUTOMATION,
  offer_contract_sent: DOMAIN_AUTOMATION,
  offer_contract_partially_signed: DOMAIN_AUTOMATION,
  offer_contract_signed: DOMAIN_AUTOMATION,
  offer_contract_canceled: DOMAIN_AUTOMATION,
  offer_contract_failed: DOMAIN_AUTOMATION,
  lease_drafted: CONTACT_DOMAIN_AUTOMATION,
  lease_activated: CONTACT_DOMAIN_AUTOMATION,
  lease_terminated: CONTACT_DOMAIN_AUTOMATION,
  lease_renewed: CONTACT_DOMAIN_AUTOMATION,
  lease_invoice_issued: FINANCIAL_DOMAIN_AUTOMATION,
  lease_invoice_paid: FINANCIAL_DOMAIN_AUTOMATION,
  lease_invoice_overdue: FINANCIAL_DOMAIN_AUTOMATION,
  lease_payment_received: FINANCIAL_DOMAIN_AUTOMATION,
  owner_payout_created: FINANCIAL_DOMAIN_AUTOMATION,
  owner_payout_approved: FINANCIAL_DOMAIN_AUTOMATION,
  owner_payout_paid: FINANCIAL_DOMAIN_AUTOMATION,
  owner_payout_canceled: FINANCIAL_DOMAIN_AUTOMATION,
  kyc_verification_requested: DOMAIN_AUTOMATION,
  kyc_verification_approved: DOMAIN_AUTOMATION,
  kyc_verification_rejected: DOMAIN_AUTOMATION,
  kyc_verification_failed: DOMAIN_AUTOMATION,
  property_diligence_opened: DOMAIN_AUTOMATION,
  property_diligence_in_review: DOMAIN_AUTOMATION,
  property_diligence_cleared: DOMAIN_AUTOMATION,
  property_diligence_blocked: DOMAIN_AUTOMATION,
  property_diligence_canceled: DOMAIN_AUTOMATION,
  property_diligence_expired: DOMAIN_AUTOMATION,
  property_transaction_opened: DOMAIN_AUTOMATION,
  property_transaction_in_progress: DOMAIN_AUTOMATION,
  property_transaction_completed: DOMAIN_AUTOMATION,
  property_transaction_canceled: DOMAIN_AUTOMATION,
  transaction_checklist_item_pending: DOMAIN_AUTOMATION,
  transaction_checklist_item_blocked: DOMAIN_AUTOMATION,
  transaction_checklist_item_started: DOMAIN_AUTOMATION,
  transaction_checklist_item_completed: DOMAIN_AUTOMATION,
  transaction_checklist_item_waived: DOMAIN_AUTOMATION,
  transaction_checklist_item_reopened: DOMAIN_AUTOMATION,
  crm_task_created: DOMAIN_AUTOMATION,
  crm_task_updated: DOMAIN_AUTOMATION,
  crm_task_status_changed: DOMAIN_AUTOMATION,
  crm_task_assigned: DOMAIN_AUTOMATION,
  crm_task_started: DOMAIN_AUTOMATION,
  crm_task_waiting: DOMAIN_AUTOMATION,
  crm_task_reopened: DOMAIN_AUTOMATION,
  crm_task_completed: DOMAIN_AUTOMATION,
  crm_task_canceled: DOMAIN_AUTOMATION,
  crm_task_sla_breached: DOMAIN_AUTOMATION,
  reservation_hold_placed: DOMAIN_AUTOMATION,
  reservation_hold_confirmed: DOMAIN_AUTOMATION,
  reservation_hold_released: DOMAIN_AUTOMATION,
  reservation_hold_expired: DOMAIN_AUTOMATION,
  reservation_hold_canceled: DOMAIN_AUTOMATION,
  imovel_price_dropped: DOMAIN_AUTOMATION,
  contact_created: DOMAIN_AUTOMATION,
  contact_updated: DOMAIN_AUTOMATION,
  lead_qualified: DOMAIN_AUTOMATION,
  lead_disqualified: DOMAIN_AUTOMATION,
  lead_assigned: DOMAIN_AUTOMATION,
  // Temporal notification events may run without a Conversation. Keep their
  // action list to writers that resolve the Contact from the visit context.
  visit_reminder_due: {
    conditions: [],
    actions: [
      {
        key: 'dispatch_notification',
        name: 'DISPATCH_NOTIFICATION',
      },
      {
        key: 'send_survey',
        name: 'SEND_SURVEY',
      },
    ],
  },
  visit_follow_up_due: {
    conditions: [],
    actions: [
      {
        key: 'dispatch_notification',
        name: 'DISPATCH_NOTIFICATION',
      },
      {
        key: 'send_survey',
        name: 'SEND_SURVEY',
      },
    ],
  },
  conversation_csat_due: {
    conditions: [],
    actions: [
      {
        key: 'send_survey',
        name: 'SEND_SURVEY',
      },
    ],
  },
};

export const AUTOMATION_RULE_EVENTS = [
  {
    key: 'conversation_created',
    value: 'CONVERSATION_CREATED',
  },
  {
    key: 'conversation_updated',
    value: 'CONVERSATION_UPDATED',
  },
  {
    key: 'conversation_resolved',
    value: 'CONVERSATION_RESOLVED',
  },
  {
    key: 'message_created',
    value: 'MESSAGE_CREATED',
  },
  {
    key: 'conversation_opened',
    value: 'CONVERSATION_OPENED',
  },
  {
    key: 'visit_requested',
    value: 'VISIT_REQUESTED',
  },
  {
    key: 'visit_confirmed',
    value: 'VISIT_CONFIRMED',
  },
  {
    key: 'visit_rescheduled',
    value: 'VISIT_RESCHEDULED',
  },
  {
    key: 'visit_canceled',
    value: 'VISIT_CANCELED',
  },
  {
    key: 'visit_completed',
    value: 'VISIT_COMPLETED',
  },
  {
    key: 'visit_no_show',
    value: 'VISIT_NO_SHOW',
  },
  {
    key: 'visit_stalled',
    value: 'VISIT_STALLED',
  },
  {
    key: 'visit_unsuccessful',
    value: 'VISIT_UNSUCCESSFUL',
  },
  {
    key: 'offer_created',
    value: 'OFFER_CREATED',
  },
  {
    key: 'offer_submitted',
    value: 'OFFER_SUBMITTED',
  },
  {
    key: 'offer_countered',
    value: 'OFFER_COUNTERED',
  },
  {
    key: 'offer_accepted',
    value: 'OFFER_ACCEPTED',
  },
  {
    key: 'offer_declined',
    value: 'OFFER_DECLINED',
  },
  {
    key: 'offer_expired',
    value: 'OFFER_EXPIRED',
  },
  {
    key: 'offer_withdrawn',
    value: 'OFFER_WITHDRAWN',
  },
  {
    key: 'offer_contract_drafted',
    value: 'OFFER_CONTRACT_DRAFTED',
  },
  {
    key: 'offer_contract_sent',
    value: 'OFFER_CONTRACT_SENT',
  },
  {
    key: 'offer_contract_partially_signed',
    value: 'OFFER_CONTRACT_PARTIALLY_SIGNED',
  },
  {
    key: 'offer_contract_signed',
    value: 'OFFER_CONTRACT_SIGNED',
  },
  {
    key: 'offer_contract_canceled',
    value: 'OFFER_CONTRACT_CANCELED',
  },
  {
    key: 'offer_contract_failed',
    value: 'OFFER_CONTRACT_FAILED',
  },
  {
    key: 'lease_drafted',
    value: 'LEASE_DRAFTED',
  },
  {
    key: 'lease_activated',
    value: 'LEASE_ACTIVATED',
  },
  {
    key: 'lease_terminated',
    value: 'LEASE_TERMINATED',
  },
  {
    key: 'lease_renewed',
    value: 'LEASE_RENEWED',
  },
  {
    key: 'lease_invoice_issued',
    value: 'LEASE_INVOICE_ISSUED',
  },
  {
    key: 'lease_invoice_paid',
    value: 'LEASE_INVOICE_PAID',
  },
  {
    key: 'lease_invoice_overdue',
    value: 'LEASE_INVOICE_OVERDUE',
  },
  {
    key: 'lease_payment_received',
    value: 'LEASE_PAYMENT_RECEIVED',
  },
  {
    key: 'owner_payout_created',
    value: 'OWNER_PAYOUT_CREATED',
  },
  {
    key: 'owner_payout_approved',
    value: 'OWNER_PAYOUT_APPROVED',
  },
  {
    key: 'owner_payout_paid',
    value: 'OWNER_PAYOUT_PAID',
  },
  {
    key: 'owner_payout_canceled',
    value: 'OWNER_PAYOUT_CANCELED',
  },
  {
    key: 'kyc_verification_requested',
    value: 'KYC_VERIFICATION_REQUESTED',
  },
  {
    key: 'kyc_verification_approved',
    value: 'KYC_VERIFICATION_APPROVED',
  },
  {
    key: 'kyc_verification_rejected',
    value: 'KYC_VERIFICATION_REJECTED',
  },
  {
    key: 'kyc_verification_failed',
    value: 'KYC_VERIFICATION_FAILED',
  },
  {
    key: 'property_diligence_opened',
    value: 'PROPERTY_DILIGENCE_OPENED',
  },
  {
    key: 'property_diligence_in_review',
    value: 'PROPERTY_DILIGENCE_IN_REVIEW',
  },
  {
    key: 'property_diligence_cleared',
    value: 'PROPERTY_DILIGENCE_CLEARED',
  },
  {
    key: 'property_diligence_blocked',
    value: 'PROPERTY_DILIGENCE_BLOCKED',
  },
  {
    key: 'property_diligence_canceled',
    value: 'PROPERTY_DILIGENCE_CANCELED',
  },
  {
    key: 'property_diligence_expired',
    value: 'PROPERTY_DILIGENCE_EXPIRED',
  },
  {
    key: 'property_transaction_opened',
    value: 'PROPERTY_TRANSACTION_OPENED',
  },
  {
    key: 'property_transaction_in_progress',
    value: 'PROPERTY_TRANSACTION_IN_PROGRESS',
  },
  {
    key: 'property_transaction_completed',
    value: 'PROPERTY_TRANSACTION_COMPLETED',
  },
  {
    key: 'property_transaction_canceled',
    value: 'PROPERTY_TRANSACTION_CANCELED',
  },
  {
    key: 'transaction_checklist_item_pending',
    value: 'TRANSACTION_CHECKLIST_ITEM_PENDING',
  },
  {
    key: 'transaction_checklist_item_blocked',
    value: 'TRANSACTION_CHECKLIST_ITEM_BLOCKED',
  },
  {
    key: 'transaction_checklist_item_started',
    value: 'TRANSACTION_CHECKLIST_ITEM_STARTED',
  },
  {
    key: 'transaction_checklist_item_completed',
    value: 'TRANSACTION_CHECKLIST_ITEM_COMPLETED',
  },
  {
    key: 'transaction_checklist_item_waived',
    value: 'TRANSACTION_CHECKLIST_ITEM_WAIVED',
  },
  {
    key: 'transaction_checklist_item_reopened',
    value: 'TRANSACTION_CHECKLIST_ITEM_REOPENED',
  },
  {
    key: 'crm_task_created',
    value: 'CRM_TASK_CREATED',
  },
  {
    key: 'crm_task_updated',
    value: 'CRM_TASK_UPDATED',
  },
  {
    key: 'crm_task_status_changed',
    value: 'CRM_TASK_STATUS_CHANGED',
  },
  {
    key: 'crm_task_assigned',
    value: 'CRM_TASK_ASSIGNED',
  },
  {
    key: 'crm_task_started',
    value: 'CRM_TASK_STARTED',
  },
  {
    key: 'crm_task_waiting',
    value: 'CRM_TASK_WAITING',
  },
  {
    key: 'crm_task_reopened',
    value: 'CRM_TASK_REOPENED',
  },
  {
    key: 'crm_task_completed',
    value: 'CRM_TASK_COMPLETED',
  },
  {
    key: 'crm_task_canceled',
    value: 'CRM_TASK_CANCELED',
  },
  {
    key: 'crm_task_sla_breached',
    value: 'CRM_TASK_SLA_BREACHED',
  },
  {
    key: 'reservation_hold_placed',
    value: 'RESERVATION_HOLD_PLACED',
  },
  {
    key: 'reservation_hold_confirmed',
    value: 'RESERVATION_HOLD_CONFIRMED',
  },
  {
    key: 'reservation_hold_released',
    value: 'RESERVATION_HOLD_RELEASED',
  },
  {
    key: 'reservation_hold_expired',
    value: 'RESERVATION_HOLD_EXPIRED',
  },
  {
    key: 'reservation_hold_canceled',
    value: 'RESERVATION_HOLD_CANCELED',
  },
  {
    key: 'imovel_price_dropped',
    value: 'IMOVEL_PRICE_DROPPED',
  },
  {
    key: 'contact_created',
    value: 'CONTACT_CREATED',
  },
  {
    key: 'contact_updated',
    value: 'CONTACT_UPDATED',
  },
  {
    key: 'lead_qualified',
    value: 'LEAD_QUALIFIED',
  },
  {
    key: 'lead_disqualified',
    value: 'LEAD_DISQUALIFIED',
  },
  {
    key: 'lead_assigned',
    value: 'LEAD_ASSIGNED',
  },
  {
    key: 'visit_reminder_due',
    value: 'VISIT_REMINDER_DUE',
  },
  {
    key: 'visit_follow_up_due',
    value: 'VISIT_FOLLOW_UP_DUE',
  },
  {
    key: 'conversation_csat_due',
    value: 'CONVERSATION_CSAT_DUE',
  },
];

export const AUTOMATION_ACTION_TYPES = [
  {
    key: 'assign_agent',
    label: 'ASSIGN_AGENT',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'ASSIGN_TEAM',
    inputType: 'search_select',
  },
  {
    key: 'add_label',
    label: 'ADD_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'remove_label',
    label: 'REMOVE_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'send_email_to_team',
    label: 'SEND_EMAIL_TO_TEAM',
    inputType: 'team_message',
  },
  {
    key: 'send_email_transcript',
    label: 'SEND_EMAIL_TRANSCRIPT',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'MUTE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'SNOOZE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'RESOLVE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'open_conversation',
    label: 'OPEN_CONVERSATION',
    inputType: null,
  },
  {
    key: 'pending_conversation',
    label: 'PENDING_CONVERSATION',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'SEND_WEBHOOK_EVENT',
    inputType: 'url',
  },
  {
    key: 'send_attachment',
    label: 'SEND_ATTACHMENT',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'SEND_MESSAGE',
    inputType: 'textarea',
  },
  {
    key: 'add_private_note',
    label: 'ADD_PRIVATE_NOTE',
    inputType: 'textarea',
  },
  {
    key: 'change_priority',
    label: 'CHANGE_PRIORITY',
    inputType: 'search_select',
  },
  {
    key: 'add_sla',
    label: 'ADD_SLA',
    inputType: 'search_select',
  },
  {
    key: 'recommend_imoveis',
    label: 'RECOMMEND_IMOVEIS',
    inputType: 'textarea',
  },
  {
    key: 'notify_agent',
    label: 'NOTIFY_AGENT',
    inputType: 'textarea',
  },
  {
    key: 'send_whatsapp_template',
    label: 'SEND_WHATSAPP_TEMPLATE',
    inputType: 'textarea',
  },
  {
    key: 'add_to_nurture_cadence',
    label: 'ADD_TO_NURTURE_CADENCE',
    inputType: 'textarea',
  },
  {
    key: 'route_imovel_lead',
    label: 'ROUTE_IMOVEL_LEAD',
    inputType: 'textarea',
  },
  {
    key: 'send_survey',
    label: 'SEND_SURVEY',
    inputType: 'search_select',
  },
  {
    key: 'dispatch_notification',
    label: 'DISPATCH_NOTIFICATION',
    inputType: null,
  },
  {
    key: 'create_crm_task',
    label: 'CREATE_CRM_TASK',
    inputType: 'crm_task',
  },
  {
    key: 'sync_domain_crm_task',
    label: 'SYNC_DOMAIN_CRM_TASK',
    inputType: null,
  },
];
